import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useInternalGetContactForBorrower } from 'core/types'

import ModelLink from './ModelLink'

type ContactLinkProps = {
  contactId: string
}

const ContactLink: FC<ContactLinkProps> = ({ contactId }) => {
  const [_, { companyId, personId }] = useQueryApi()
  const { data: contact, isLoading } = useInternalGetContactForBorrower({
    companyId,
    personId,
    contactId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link =
    companyId &&
    personId &&
    `/companies/${companyId}/borrowers/${personId}/contacts/${contactId}`

  return (
    <ModelLink
      id={contactId}
      isLoading={isLoading}
      link={link}
      model={contact}
    />
  )
}

export default ContactLink
